export const APP_TITLE = 'DirPlayer App';
